/* eslint-disable import/prefer-default-export */
import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { upgradeAccountScreens } from '../../../screens/UserSettings/Account/UpgradeAccount/constant';
import { upgradeAccount } from './reducer';

const initUpgradeAccountState = {
  currentScreen: upgradeAccountScreens.START_UPGRADE,
  screenOptions: {},
  verificationNoteOpened: false,
  verificationNoteType: 'proof_of_address',
  riskTier: null,
  selectedSourceOfWealth: null,
  selectedBusinessSector: null,
  tiersStandard: null,
  currentTier: null,
  nextTierInfo: null,
};

export const UpgradeAccountContext = createContext(initUpgradeAccountState);

export const UpgradeAccountProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    upgradeAccount?.UpgradeAccountReducer,
    initUpgradeAccountState
  );

  const boundActions = {};
  // eslint-disable-next-line guard-for-in, guard-for-in
  for (const key in upgradeAccount?.actions) {
    boundActions[key] = upgradeAccount.actions[key](dispatch);
  }

  return (
    <UpgradeAccountContext.Provider value={{ state, ...boundActions }}>
      {children}
    </UpgradeAccountContext.Provider>
  );
};

UpgradeAccountProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
